import { Typography, Button } from 'antd'
import { Download, ArrowLeft } from 'lucide-react'
import { ReportHeader as ReportHeaderWrapper } from '../../styles/ReportPageStyles'

import { FONT_WEIGHT, TYPOGRAPHY } from '../../../styles/theme'
import { PRINT_LIGHT_MODE_OVERRIDES } from '../../../styles/pageHeaderStyles'
const { Title } = Typography

const PRINT_STYLES = `
  @page {
    margin: 0;
  }

  @media print {
    body {
      margin: 0;
      padding: 20px;
    }
    ${PRINT_LIGHT_MODE_OVERRIDES}
  }
`

interface ReportHeaderBarProps {
  title: string
  onBack: () => void
  onExport: () => void
}

export function ReportHeaderBar({ title, onBack, onExport }: ReportHeaderBarProps) {
  return (
    <>
      <style>{PRINT_STYLES}</style>
      <ReportHeaderWrapper>
        <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
          <button
            className="no-print"
            onClick={onBack}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              background: 'none',
              border: 'none',
              padding: '4px 0',
              marginTop: 4,
              cursor: 'pointer',
              color: 'var(--color-text-secondary)',
              fontSize: TYPOGRAPHY.caption.fontSize,
              fontWeight: FONT_WEIGHT.medium,
              letterSpacing: 0,
              lineHeight: 1,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--color-text-primary)')}
            onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--color-text-secondary)')}
          >
            <ArrowLeft size={14} strokeWidth={2} />
            Back
          </button>
          <Title level={2} style={{ margin: 0 }}>
            {title}
          </Title>
        </div>
        <Button
          type="primary"
          icon={<Download size={16} />}
          onClick={onExport}
          className="no-print"
        >
          Export as PDF
        </Button>
      </ReportHeaderWrapper>
    </>
  )
}
